import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

/** Admin auth (httpOnly cookie) + messages management. */
export function useAdminMessages() {
  const [authed, setAuthed] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/messages");
      setMessages(r.data);
      setAuthed(true);
      setError("");
    } catch {
      setAuthed(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      setError("");
      await load();
    } catch {
      setError("Credenziali non valide");
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // cookie clear failed server-side; still reset the UI
    }
    setAuthed(false);
    setMessages([]);
  };

  const markRead = async (id) => {
    await api.put(`/admin/messages/${id}`);
    setMessages((ms) => ms.map((m) => (m.id === id ? { ...m, read: true } : m)));
  };

  const remove = async (id) => {
    await api.delete(`/admin/messages/${id}`);
    setMessages((ms) => ms.filter((m) => m.id !== id));
  };

  const reply = async (id, text) => {
    const r = await api.post(`/admin/messages/${id}/reply`, { text });
    setMessages((ms) =>
      ms.map((m) =>
        m.id === id
          ? { ...m, read: true, reply_text: text, replied_at: r.data.replied_at }
          : m
      )
    );
    return r.data;
  };

  return { authed, messages, loading, error, login, logout, markRead, remove, reply };
}
